import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingCount = 0;
  private _loading = new BehaviorSubject<boolean>(false);

  readonly loading$ = this._loading.asObservable();

  show() {
    this.loadingCount++;
    if (this.loadingCount === 1) {
      this._loading.next(true);
    }
  }

  hide() {
    if (this.loadingCount > 0) {
      this.loadingCount--;
    }
    if (this.loadingCount === 0) {
      this._loading.next(false);
    }
  }
}
